import { render, staticRenderFns } from "./CardAdminFounder.vue?vue&type=template&id=0212ef9f"
import script from "./CardAdminFounder.vue?vue&type=script&lang=js"
export * from "./CardAdminFounder.vue?vue&type=script&lang=js"
import style0 from "./CardAdminFounder.vue?vue&type=style&index=0&id=0212ef9f&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports